import React from 'react';

import DateBox from 'devextreme-react/date-box';


export const FormDateBox = ({
  value,
  readOnly,
  name,
  label,
  allowClear,
  onValueChange,
  children
}) => {
  return (
    <DateBox
      value={value}
      readOnly={readOnly}
      name={name}
      label={label}
      inputAttr={{ class: 'form-editor-input' }}
      stylingMode='filled'

      displayFormat='dd.MM.yyyy'
      allowClear={true}
      onValueChange={onValueChange}
    >
        {children}
    </DateBox>
  );
};
